import store from "../store/index"

export const existingResourcePaths = (projectID) => {
  const existingResources =
    store.getState().projects.byId(projectID).resources || []

    return existingResources.flatMap(resourceArray =>
      resourceArray.map(resourceObject => resourceObject.path)
    )
}